import { origin } from './constant';

const DictionaryURI = {
  dictionaryURI: `${origin}/dictionaries/:key`,
};

export default DictionaryURI;
